//Закладки ссылки
export const FAVLINKS_REQUEST = 'FAVLINKS_REQUEST';
export const FAVLINKS_SUCCESS = 'FAVLINKS_SUCCESS';
export const FAVLINKS_FAIL = 'FAVLINKS_FAIL';

export const FAVLINKSDEL_REQUEST = 'FAVLINKSDEL_REQUEST';
export const FAVLINKSDEL_SUCCESS = 'FAVLINKSDEL_SUCCESS';
export const FAVLINKSDEL_FAIL = 'FAVLINKSDEL_FAIL';


//Заклаки пользователи
export const FAVUSER_REQUEST = 'FAVUSER_REQUEST';
export const FAVUSER_SUCCESS = 'FAVUSER_SUCCESS';
export const FAVUSER_FAIL = 'FAVUSER_FAIL';

export const FAVUSERDEL_REQUEST = 'FAVUSERDEL_REQUEST';
export const FAVUSERDEL_SUCCESS = 'FAVUSERDEL_SUCCESS';
export const FAVUSERDEL_FAIL = 'FAVUSERDEL_FAIL';

//Закладки видео
export const FAVVIDEO_REQUEST = 'FAVVIDEO_REQUEST';
export const FAVVIDEO_SUCCESS = 'FAVVIDEO_SUCCESS';
export const FAVVIDEO_FAIL = 'FAVVIDEO_FAIL';

export const FAVVIDEODEL_REQUEST = 'FAVVIDEODEL_REQUEST';
export const FAVVIDEODEL_SUCCESS = 'FAVVIDEODEL_SUCCESS';
export const FAVVIDEODEL_FAIL = 'FAVVIDEODEL_FAIL';

//закладки посты
export const FAVPOSTS_REQUEST = 'FAVPOSTS_REQUEST';
export const FAVPOSTS_SUCCESS = 'FAVPOSTS_SUCCESS';
export const FAVPOSTS_FAIL = 'FAVPOSTS_FAIL';

export const FAVPOSTSDEL_REQUEST = 'FAVPOSTSDEL_REQUEST';
export const FAVPOSTSDEL_SUCCESS = 'FAVPOSTSDEL_SUCCESS';
export const FAVPOSTSDEL_FAIL = 'FAVPOSTSDEL_FAIL';

//закладки товары
export const FAVMARKIT_REQUEST = 'FAVMARKIT_REQUEST';
export const FAVMARKIT_SUCCESS = 'FAVMARKIT_SUCCESS';
export const FAVMARKIT_FAIL = 'FAVMARKIT_FAIL';

export const FAVMARKITDEL_REQUEST = 'FAVMARKITDEL_REQUEST';
export const FAVMARKITDEL_SUCCESS = 'FAVMARKITDEL_SUCCESS';
export const FAVMARKITDEL_FAIL = 'FAVMARKITDEL_FAIL';

//favs photo
export const FAVPHOTO_REQUEST = 'FAVPHOTO_REQUEST';
export const FAVPHOTO_SUCCESS = 'FAVPHOTO_SUCCESS';
export const FAVPHOTO_FAIL = 'FAVPHOTO_FAIL';

export const FAVPHOTODEL_REQUEST = 'FAVPHOTODEL_REQUEST';
export const FAVPHOTODEL_SUCCESS = 'FAVPHOTODEL_SUCCESS';
export const FAVPHOTODEL_FAIL = 'FAVPHOTODEL_FAIL';

export const FAVPHOTO_SHOWGALERY = 'FAVPHOTO_SHOWGALERY';
export const FAVPHOTO_SHOWMORE = 'FAVPHOTO_SHOWMORE';
export const FAVPHOTO_SELECTIMAGE = 'FAVPHOTO_SELECTIMAGE';
export const FAVPHOTO_SELECTALL = 'FAVPHOTO_SELECTALL';


//закладки капча
export const CAPTCHA_NEEDED = 'CAPTCHA_NEEDED';
export const CAPTCHA_SET = 'CAPTCHA_SET';
export const CAPTCHA_CANCEL = 'CAPTCHA_CANCEL';
export const CAPTCHA_SUBMITED = 'CAPTCHA_SUBMITED';



// WEBPACK FOOTER //
// ./src/constants/Favs.js